
import { useState } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { fetchOnboardingRequests } from '@/services/admin';
import { useClientFiltering } from './useClientFiltering';

/**
 * Hook for loading and managing client request data
 */
export const useClientData = () => {
  const { toast } = useToast();
  const { getFilteredRequests } = useClientFiltering();
  const [onboardingRequests, setOnboardingRequests] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("client-requests");

  // Create computed lists that will always reflect the current state
  const createFilteredLists = (requests: any[], filterStatus: string) => {
    const pendingRequests = getFilteredRequests(
      requests.filter(req => 
        req.status === 'pending_verification' || req.status === 'pending'
      ),
      filterStatus
    );
    
    const verifiedClients = getFilteredRequests(
      requests.filter(req => 
        req.status === 'verified' || req.status === 'approved'
      ),
      filterStatus
    );
    
    const rejectedClients = getFilteredRequests(
      requests.filter(req => 
        req.status === 'rejected'
      ),
      filterStatus
    );

    return { pendingRequests, verifiedClients, rejectedClients };
  };

  const loadOnboardingRequests = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await fetchOnboardingRequests();
      
      if (error) {
        toast({
          title: "Error",
          description: "Failed to load onboarding requests.",
          variant: "destructive",
        });
        return;
      }
      
      console.log("Setting onboarding requests:", data);
      setOnboardingRequests(data);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onboardingRequests,
    setOnboardingRequests,
    isLoading,
    activeTab,
    setActiveTab,
    loadOnboardingRequests,
    createFilteredLists
  };
};
